import createTheme from '@mui/material/styles/createTheme';
import breakpoints from './breakpoints/breakpoints';
import colors from './colors';
import neutrals from './neutrals';
import overlays from './overlays';
import palette from './palette';
import shades from './shades';
import shadows from './shadows';
import typography from './typography';
const theme = createTheme({
    palette,
    breakpoints,
    typography,
    colors,
    shades,
    // Ignore shadows being set as an interface instead of type
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // shadows,
    shadows,
    overlays,
    neutrals,
    components: {
        MuiFormLabel: {
            styleOverrides: {
                asterisk: {
                    color: palette.error.main,
                },
            },
        },
    },
});
export default theme;
//# sourceMappingURL=theme.js.map